import React, { useState, useEffect } from 'react';
import Popup from 'reactjs-popup';
import themeLight from '../../../../assets/images/light-theme.png'
import themeDark from '../../../../assets/images/dark-theme.png'
import themeDefault from '../../../../assets/images/default_theme.png'
import { Link } from 'react-router-dom';

const AppThemePopup = ({openModal, setOpen}) => {
    const [currentTheme, setCurrentTheme] = useState(localStorage.getItem('preferred-theme') || 'system');
    
    const closeModal = () => setOpen(false);
    
    const handleThemeChange = (theme) => {
        setCurrentTheme(theme);
        
        localStorage.setItem('preferred-theme', theme);
        
        switch (theme) {
            case 'system':
                if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    document.documentElement.setAttribute('data-theme', 'dark');
                } else {
                    document.documentElement.setAttribute('data-theme', 'light');
                }
                break;
            case 'light':
            case 'dark':
                document.documentElement.setAttribute('data-theme', theme);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        if (openModal) {
            setCurrentTheme(localStorage.getItem('preferred-theme') || 'system');
        }
    }, [openModal]);

    return (
        <Popup open={openModal} closeOnDocumentClick onClose={closeModal} lockScroll={true}>
            <Link className="close-modal" onClick={closeModal}>&times;</Link>
            <div className="modal app-theme-popup">
                <div className="modal-header">
                    <h3>Appearance Settings</h3>
                    <p>Choose your preferred interface appearance. You have the option to pick a theme manually or enable automatic theme switching that aligns with your system settings.</p>
                </div>
                <div className="modal-content">
                    <div className="theme-app-wrapper">
                        <div 
                            className={`app-single-theme ${currentTheme === 'system' ? 'active-theme' : ''}`}
                            onClick={() => handleThemeChange('system')}
                        >
                            <h4><i className="ri-computer-line"></i> System Theme</h4>
                            <img src={themeDefault} alt="Default theme"/>
                            <h5>Default</h5>
                            <p>This theme will use the theme your system is using.</p>
                        </div>
                        <div 
                            className={`app-single-theme ${currentTheme === 'light' ? 'active-theme' : ''}`}
                            onClick={() => handleThemeChange('light')}
                        >
                            <h4><i className="ri-sun-line"></i> Light Theme</h4>
                            <img src={themeLight} alt="light theme"/>
                            <h5>Light mode</h5>
                            <p>This theme will use the light theme.</p>
                        </div>
                        <div 
                            className={`app-single-theme ${currentTheme === 'dark' ? 'active-theme' : ''}`}
                            onClick={() => handleThemeChange('dark')}
                        >
                            <h4><i className="ri-moon-fill"></i> Dark Theme</h4>
                            <img src={themeDark} alt="Dark theme"/>
                            <h5>Dark mode</h5>
                            <p>This theme will use the dark theme.</p>
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default AppThemePopup;